// extracted by mini-css-extract-plugin
export default {"Info":"InfoText_Info__Vu9lX","InfoText":"InfoText_InfoText__O3idv"};